/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { TutorAITokenBreakdownViewModel } from "../types/TutorAITokenBreakdownViewModel.ts";

export const tutorAITokenBreakdownViewModelSchema = z.object({
  provider: z
    .string()
    .describe(
      "Nome do provedor de IA responsável pelo consumo (ex: Google, OpenAI).",
    )
    .nullish(),
  operation: z
    .string()
    .describe("Tipo de operação realizada (ex: chat, embedding).")
    .nullish(),
  tokensUsed: z.optional(
    z
      .number()
      .int()
      .describe(
        "Quantidade de tokens consumidos nesta combinação de provedor e operação.",
      ),
  ),
}) as unknown as ToZod<TutorAITokenBreakdownViewModel>;
